/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from 'react'

import Menu from '../../../components/CustomerClub/Menu'

import { get } from '../../../services/http'
import { notify } from '../../../components/Toast'

import ReactPaginate from 'react-paginate'
import { useNavigate } from 'react-router-dom'

import { ToastContainer } from 'react-toastify'

import orderIcon from '../../../assets/svg/orderIcon.svg'
import Table from '../../../components/OrderList/'

function index() {
  document.title = 'لیست سفارش‌ها'

  const navigate = useNavigate()

  const [orders, setOrders] = useState([])
  const [ordersCount, setOrdersCount] = useState()
  const [totalPage, setTotalPage] = useState()

  const token = localStorage.getItem('token')

  useEffect(() => {
    get(`/api/admin/order?token=${token}`)
      .then(response => {
        setOrders(response.data.data)
        setTotalPage(response.data.pages)
        setOrdersCount(response.data.total)
      })
      .catch(error => {
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }, [token])

  const handlePageClick = (event) => {
    get(`/api/admin/order?page=${event.selected + 1}&token=${token}`)
    .then(response => {
      setOrders(response.data.data)
      setTotalPage(response.data.pages)
      setOrdersCount(response.data.total)
    }).catch(error => {
      notify('error', 'دریافت اطلاعات با خطا مواجه شد')
    })
  }

  const navigateHandler = () => {
    navigate('/orders/select')
  }

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'orders'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className="right">
              <div className='icon'>
                <img src={orderIcon} alt='resturantIcon' />
              </div>
              <div className='text'>
                ‌‌سفارش‌ها
              </div>
            </div>
            <div className="left">
              <button onClick={navigateHandler}>کلیه سفارشات</button>
            </div>
          </div>

          <div className="tablePart">
            <div className="title">
              <div className="right">
                تعداد کل سفارشات
              </div>
              <div className="left">
                {ordersCount}
              </div>
            </div>

            <Table data={orders} />
            <ReactPaginate 
              breakLabel="..."
              nextLabel="بعدی"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={totalPage}
              previousLabel="قبلی"
              renderOnZeroPageCount={null}
            />
          </div>

          <div className="copyright">
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}

export default index